export default {
	cities: 'Города',
	stocks: 'Склады',
	accounts: 'Аккаунты',
	roles: 'Роли',
	reports: 'Отчеты',
	appeals: 'Обращения',
	edit: 'Редактировать',
	exit: 'Выйти',
	changePassword: 'Сменить пароль',
	boxes: 'Боксы',
	myBoxes: 'Мои боксы',
	profile: 'Профиль',
	support: 'Поддержка',
	book: 'Забронировать',
	toHome: 'Главная',
	topDebtors: 'Топ-10 должников',
	monthlyBills: 'Счета за месяц',
	Subscriptions: 'Подписки',
	externalPayments: 'Платежи',
	notSentInvoicesEmails: 'Неотправленные уведомления о счетах',
	notificationsOfPenalty: 'Уведомления о штрафах',
	issueTheFirstPenaltyInvoice: 'Выставить первый штрафной счёт',
	unknownNotification: 'Неизвестное уведомление',
	markAsCompleted: 'пометить как завершённое',
	completed: 'Завершено',
	usersImport: 'Импорт пользователей',
	import: 'Импортировать',

	emailHistory: 'История писем',
	unpaidDebts: (span_color) => `У Вас есть неоплаченные <span style="color: ${span_color}">задолженности</span>`,
};
